import {UserExamGrade} from '../stats/Stats';

export enum UserCertificateType {
  teacher = 'teacher',
}

export type CertificateType = UserExamGrade | UserCertificateType;

export class CertificateTextConfig {
  public static readonly DEFAULT_FONT_SIZE = 96;

  public font_size: number;
  public x1: number;
  public y1: number;
  public x2: number;
  public y2: number;

  constructor(font_size: number, x1: number, y1: number, x2: number, y2: number) {
    this.font_size = font_size;
    this.x1 = x1;
    this.y1 = y1;
    this.x2 = x2;
    this.y2 = y2;
  }

  public static parse(dto: CertificateTextConfigDto): CertificateTextConfig {
    return new CertificateTextConfig(dto.font_size, dto.x1, dto.y1, dto.x2, dto.y2);
  }
}

export interface CertificateTextConfigDto {
  font_size: number;
  x1: number;
  y1: number;
  x2: number;
  y2: number;
}

export class Certificate {
  public type?: CertificateType;
  public url?: string;

  public primary_config?: CertificateTextConfig;
  public secondary_config?: CertificateTextConfig;

  constructor(type?: CertificateType) {
    this.type = type;
  }

  public static parse(dto: CertificateDto): Certificate {
    const certificate = new Certificate(dto.type);

    certificate.url = dto.url;
    if (dto.primary_config) certificate.primary_config = CertificateTextConfig.parse(dto.primary_config);
    if (dto.secondary_config) certificate.secondary_config = CertificateTextConfig.parse(dto.secondary_config);

    return certificate;
  }
}

export interface CertificateDto {
  type?: CertificateType;
  url: string;

  primary_config: CertificateTextConfigDto;
  secondary_config?: CertificateTextConfigDto;
}

export interface TestCertificateData {
  primary_text: string;
  secondary_text?: string;
}
